module.exports = __webpack_public_path__ + "static/media/corporate-services-img90.5d165d1f.jpg";